import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AboutUsComponent } from 'src/app/view/about-us/about-us.component';
import { CommitteeComponent } from 'src/app/view/about-us/committee/committee.component';
import { GoverningComponent } from 'src/app/view/about-us/governing/governing.component';
import { MessagesComponent } from 'src/app/view/about-us/messages/messages.component';
import { ProfileComponent } from 'src/app/view/about-us/profile/profile.component';
import { StaffComponent } from 'src/app/view/about-us/staff/staff.component';
import { AboutUsRoutingModule } from './about-us-routing.module';
import { OrganogramComponent } from 'src/app/view/about-us/organogram/organogram.component';
import { RtiComponent } from 'src/app/view/about-us/rti/rti.component';
import { PerspectiveComponent } from 'src/app/view/about-us/perspective/perspective.component';
import { SearchComponent } from 'src/app/view/about-us/search/search.component';
import { ResearchCentreComponent } from 'src/app/view/about-us/research-centre/research-centre.component';
import { VisionPlanComponent } from 'src/app/view/about-us/vision-plan/vision-plan.component';
import { NaacAccreditationComponent } from 'src/app/view/about-us/naac-accreditation/naac-accreditation.component';
import { RecognitionsComponent } from 'src/app/view/about-us/recognitions/recognitions.component';
import { FinancialsComponent } from 'src/app/view/about-us/financials/financials.component';
import { AdministrationComponent } from 'src/app/view/about-us/administration/administration.component';
import { ResearchProjectComponent } from 'src/app/view/about-us/research-project/research-project.component';
import { SeminarConferenceComponent } from 'src/app/view/about-us/seminar-conference/seminar-conference.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';



@NgModule({
  declarations: [
    AboutUsComponent,
    ProfileComponent,
    GoverningComponent,
    MessagesComponent,
    StaffComponent,
    CommitteeComponent,
    OrganogramComponent,
    RtiComponent,
    PerspectiveComponent,
    SearchComponent,
    ResearchCentreComponent,
    VisionPlanComponent,
    NaacAccreditationComponent,
    RecognitionsComponent,
    FinancialsComponent,
    AdministrationComponent,
    ResearchProjectComponent,
    SeminarConferenceComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AboutUsRoutingModule,
    PdfViewerModule
  ]
})
export class AboutUsModule { }
